// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1-euS","bigColWidth":"Table_bigColWidth__36x1C","biggerColWidth":"Table_biggerColWidth__3tDvr","row":"Table_row__39C_s","col":"Table_col__2b61P"};